<template>
  <div>

    <div slot="page-header-right">
      <button class="button is-primary" @click="createUser()">
        <b-icon icon="plus"></b-icon>
         <span>
            {{$tc('add.user')}}
        </span>
      </button>
    </div>
    <b-modal :active.sync="createNewUser" :width="640" scroll="keep">
      <div class="card">
        <div class="card-content">
          <form @submit.prevent="save">
            <div id="app" class="container">
              <section>
                <b-field label="Registration">
                  </b-field>
                <b-field label="Email">
                  <b-input type="email"
                    maxlength="30"
                    v-model="form.email">
                  </b-input>
                </b-field>

                <b-field label="Password">
                  <b-input
                    type="password"
                    maxlength="30"
                    password-reveal
                    v-model="form.password"
                  ></b-input>
                </b-field>
                <b-field label="Name">
                  <b-input
                    v-model="form.name"
                    maxlength="30"
                    ></b-input>
                </b-field>
              </section>
            </div>
          <div class="is-pulled-right">
              <b-button type="button" @click="createNewUser = false">Cancel</b-button>
              <button class="button is-primary">
                <b-icon icon="content-save"></b-icon>
                <span>save</span>
              </button>
            </div>
          </form>
          <br>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>

export default {
  data() {
    return {
      createNewUser: false,
      form: new window.Form({
        password: "",
        name: "",
        email: "",
      }),
    };
  },

  props: {
    whenUpdated: {
      type: Function,
      default: () => () => {}
    }
  },

  methods: {
    createUser() {
      this.createNewUser = true;
    },

    save() {
      this.form.post("/admin/api/users").then(() => {
        this.$buefy.toast.open({
          type: "is-success",
          message: "Successfully saved."
        });
        this.form.name = null;
        this.form.password = null;
        this.form.email = null;
        this.$emit('added');

        this.createNewUser = false;
      });
    },
  },
  watch: {
    $route() {
      this.load();
    }
  },

};
</script>
